module.exports = __webpack_public_path__ + "assets/img/placeholder/card-image--trm.jpg";